import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "iconRightCaret",
  "use": "iconRightCaret-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"iconRightCaret\">\n<g id=\"iconRightCaret_general/dropdown\">\n<path id=\"iconRightCaret_web/icons/general/dropdown-chevron-closed\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17.4139 16.0002L14.5858 18.8283L16 20.2426L20.2426 15.9999L18.8284 14.5857L18.8281 14.586L15.9997 11.7575L14.5855 13.1718L17.4139 16.0002Z\" fill=\"#2D2D2D\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol